import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import { BoxCenterStart } from '../style/box'
import ReportApprovalDialog from '../components/report_approval_dialog';
import ReportRejectApprovalDialog from '../components/report_reject_approval_dialog'

export default function ReportApproval({report_or_inspection_uuid, earthquake_uuid, setTaskStatus, type, report_uuid}) {
  return (
    <>
      <BoxCenterStart>
          <ReportApprovalDialog report_or_inspection_uuid={report_or_inspection_uuid} earthquake_uuid={earthquake_uuid} setTaskStatus={setTaskStatus} type={type} report_uuid={report_uuid} />
          <ReportRejectApprovalDialog report_or_inspection_uuid={report_or_inspection_uuid} earthquake_uuid={earthquake_uuid} type={type} report_uuid={report_uuid} />
      </BoxCenterStart>
    </>
  );
}